// @ts-ignore-file
import React, { PureComponent } from "react";

const { Jodit } = require("jodit");
//import Jodit from "jodit";
import createStyles from "@material-ui/styles/createStyles";
import withStyles from "@material-ui/core/styles/withStyles";
import { Theme } from "@material-ui/core/styles/createMuiTheme";
import Chip from "@material-ui/core/Chip";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import MyPATDialog from "../../../../common/MyPATDialog";
import contentService from "../../../services/contentService";
import cx from "classnames";
import "jodit/build/jodit.min.css";
import MyPATImageUploader from "../../../../common/MyPATImageUploader";
import _ from "lodash";
import config from '../../../../../config/config';

const styles = (theme: Theme) =>
  createStyles({
    cancleBtn: {
      fontWeight: 600,
      fontSize: "14px",
      lineHeight: "19px",
      color: "#1d7dea",
      wordSpacing: 0.5,
      padding: "9px 25px",
    },
    doneBtn: {
      fontWeight: 600,
      fontSize: "14px",
      lineHeight: "19px",
      backgroundColor: "#1d7dea",
      color: "#fff",
      wordSpacing: 0.5,
      padding: "9px 25px",
      "&:hover": {
        backgroundColor: "#1d7dea",
        color: "#fff",
      },
    },
    chip: {
      border: "1px solid #1D7DEA",
      fontWeight: 600,
      fontSize: "12px",
      lineHeight: "16px",
      padding: "6px 24px",
      margin: "0px 12px 12px 0px",
      "&:hover": {
        color: "#fff",
      },
      "&:focus": {
        backgroundColor: "#1d7dea",
        color: "#fff",
      },
    },
    chipInactive: {
      backgroundColor: "transparent!important",
      color: "#1d7dea!important",
    },
    chipActive: {
      backgroundColor: "#1d7dea",
      color: "#fff",
    },
    dialogHeading: {
      fontSize: "16px",
      lineHeight: "22px",
      color: "#666",
      textAlign: "left",
      margin: "0px 0 12px 0",
    },
    minHeight: {
      minHeight: "325px",
    },
    editorWrapper: {
      width: "100%",
    },
    dialogContentbox: {
      maxHeight: 'calc(100vh - 270px)',
    }
  });

interface Props {
  classes: any;
  onClose: any;
  onDone: any;
  open: boolean;
  authUser?: any;
  questionId?: string;
}

enum IssueArea {
  AMBIGIOUS_CONTENT = "Ambigious Content",
  INCORRECT_OPTION_OR_ANSWER = "Incorrect Options/Answer",
  INCORRECT_SOLUTION = "Incorrect Solution",
  INCORRECT_CONCEPT = "Incorrect concept",
  INCORRECT_DIFFICULTY_OR_SKILL = "Incorrect Difficulty/Skill",
}

interface State {
  issueArea: IssueArea[];
  issueDescription: string;
  isLoading: boolean;
  attachments: File[];
}

const NO_OF_ATTACHMENTS_ALLOWED = 4;

class AddChallengePopup extends PureComponent<Props, State> {
  jodit: any = {};
  handleJoditOnChange: (value: string) => void;
  constructor(props: Props) {
    super(props);
    this.state = {
      issueArea: [IssueArea.AMBIGIOUS_CONTENT],
      issueDescription: "",
      isLoading: false,
      attachments: [],
    };
    this.jodit = {};
    this.handleJoditOnChange = _.debounce(this.onJoditValueChange, 400);
  }

  onJoditValueChange = (value: string) => {
    this.setState({
      issueDescription: value,
    });
  };

  componentDidMount() {
    setTimeout(() => {
      this.configureJodit();
    }, 10);
  }

  configureJodit = () => {
    const editorElem = document.getElementById("editor");
    if (!editorElem) {
      return;
    }
    this.jodit = new Jodit(editorElem, {
      buttons: joditButtons,
      buttonsMD: joditButtons,
      buttonsSM: joditButtons,
      buttonsXS: joditButtons,
      events: {
        change: this.handleJoditOnChange,
      },
    });
  };

  setAttachments = (attachments: File[]) => {
    this.setState({
      attachments,
    });
  };

  changeIssueArea = (issueArea: IssueArea) => {
    this.setState((prevState) => {
      const filteredIssueAreas = prevState.issueArea.filter(
        (val) => val !== issueArea
      );
      if (filteredIssueAreas.length === prevState.issueArea.length) {
        // the issueArea didnt exist so add it back
        filteredIssueAreas.push(issueArea);
      }
      return {
        ...prevState,
        issueArea: filteredIssueAreas,
      };
    });
  };

  handleSingleAttachment = async (attachment: File, questionId: string) => {
    try {
      const payload = {
        fileName: attachment.name, questionId, contentType: attachment.type
      }
      const response = await contentService.getPresignedUrlForQuestionReviewAttachment(
        payload
      );
      const {
        data: { fields },
      } = response;
      const { key } = fields;
      const urlParts = (response.data.url || '').split('/');
      const [header, nonHeader, awsUrl, bucket] = urlParts;
      const uploadUrl = `${header}//${bucket}.${awsUrl}/` || config.challengeQuestionBucketUrl;

      await contentService.uploadAttachment({
        file: attachment,
        uploadUrl,
        s3Fields: fields,
        // contentType: attachment.type
      });

      return `${uploadUrl}${key}`;
    } catch (error) {
      return Promise.reject(error.message);
    }
  };

  handleAttachments = async () => {
    try {
      const { attachments } = this.state;
      const { questionId } = this.props;
      if (!attachments || attachments.length === 0) {
        return [];
      }

      const promiseArr = attachments.map((attachment) => {
        return this.handleSingleAttachment(attachment, questionId!);
      });
      const urls = await Promise.all(promiseArr);
      return urls;
    } catch (error) {
      return Promise.reject(error.message);
    }
  };

  handleDone = async () => {
    const { issueArea, issueDescription, attachments } = this.state;
    try {
      this.setState({
        isLoading: true,
      });
      const { questionId, authUser } = this.props;
      if (questionId && authUser) {
        const attachmentS3Urls: string[] = await this.handleAttachments();
        await contentService.createQuestionReview({
          questionId,
          reviewerId: authUser._id,
          reviewerName: authUser.fullName,
          issueArea: issueArea.join(", "),
          issueDescription,
          attachments: attachmentS3Urls,
        });
      }
      this.props.onDone();
    } catch (error) {
      console.log(error);

      this.setState({
        isLoading: false,
      });
    }
  };

  render() {
    const { classes, onClose, open } = this.props;
    const { isLoading, issueArea, issueDescription, attachments } = this.state;
    const isValid =
      issueArea &&
      issueDescription &&
      attachments &&
      attachments.length <= NO_OF_ATTACHMENTS_ALLOWED;
    return (
      <MyPATDialog
        dialogOpen={open}
        dialogHasActions={true}
        dialogHeading={"Add a Comment"}
        isAlignCenter={true}
        customButtonVariant="withoutBorderCloseIcon"
        onDialogClose={onClose}
        isCustomBackground={false}
        isborderDialogAction={false}
        otherDialogProps={{
          fullWidth: false,
          maxWidth: "sm",
        }}
        customDialogActions={
          <>
            <div className={classes.txtRight}>
              <Button className={classes.cancleBtn} autoFocus onClick={onClose}>
                Cancel
              </Button>
              <Button
                variant="contained"
                color="primary"
                className={cx((!isValid || isLoading) && classes.disabled)}
                autoFocus
                onClick={this.handleDone}
                disabled={!isValid || isLoading}
              >
                {isLoading ? "Saving..." : "Done"}
              </Button>
            </div>
          </>
        }
      >
        <Grid
          container
          direction="row"
          justify="flex-start"
          className={classes.dialogContentbox}
        >
          <Typography className={classes.dialogHeading}>
            Specify issue areas in the content:
          </Typography>
          <div className={classes.root}>
            {Object.values(IssueArea).map((issueArea) => {
              const isActive = this.state.issueArea.includes(issueArea);

              return (
                <Chip
                  key={issueArea}
                  label={issueArea}
                  onClick={() => this.changeIssueArea(issueArea)}
                  className={[
                    classes.chip,
                    isActive ? classes.chipActive : classes.chipInactive,
                  ].join(" ")}
                  color="primary"
                />
              );
            })}
          </div>
          <div className={classes.editorWrapper}>
            <textarea id="editor" name="editor" />
          </div>
          <MyPATImageUploader
            onChange={this.setAttachments}
            maxNoOfSelections={NO_OF_ATTACHMENTS_ALLOWED}
            showPreview
            multiple
            accept="image/*"
            loading={isLoading}
            allowedFileTypes={["jpg", "png", "jpeg"]}
          />
        </Grid>
      </MyPATDialog>
    );
  }
}

const joditButtons = ["bold", "italic", "underline", "|", "font", "fontsize", "|", "ul"];

//@ts-ignore
export default withStyles(styles)(AddChallengePopup);
